import jwtDecode from "jwt-decode";
import Vue from "vue";
import Vuex from "vuex";
import router from "../router";
import { getChannelProfile } from "@/graphql/Query";
import {
  createLog,
  createOnline,
  deleteOnline,
  updateContent
} from "@/graphql/Mutation";
import apolloClient from "../plugins/vue-appsync-client";
import moment from "moment";
import uploadWorker from "@/upload-worker";

const showPercent = function(digit) {
  let n;
  if (digit < 10) {
    n = "0" + digit.toString();
  } else if (digit > 9 && digit < 99) {
    n = digit.toString();
  } else {
    n = "100";
  }
  return n + "%";
};

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    onlineId: "",
    Sidebar_drawer: null,
    Customizer_drawer: false,
    SidebarColor: "white",
    SidebarBg: "",
    navbarColor: "blue darken-1",
    user: null,
    channel: null,
    channelId: null,
    liveId: null,
    contentId: null,
    timeIdOnline: null,
    uploadingContent: [],
    pageOptions: {},
    channelDisk: {}
  },
  mutations: {
    SET_ONLINE_ID(state, payload) {
      state.onlineId = payload;
    },
    SET_SIDEBAR_DRAWER(state, payload) {
      state.Sidebar_drawer = payload;
    },
    SET_CUSTOMIZER_DRAWER(state, payload) {
      state.Customizer_drawer = payload;
    },
    SET_SIDEBAR_COLOR(state, payload) {
      state.SidebarColor = payload;
    },
    SET_NAVBAR_COLOR(state, payload) {
      state.navbarColor = payload;
    },
    SET_LAYOUT(state, payload) {
      state.setHorizontalLayout = payload;
    },
    SET_USER(state, payload) {
      state.user = payload;
    },
    SET_CHANNEL_ID(state, payload) {
      state.channelId = payload;
    },
    SET_CHANNEL(state, payload) {
      console.log("SET_CHANNEL", payload);
      state.channel = payload;
    },
    SET_CHANNEL_NAME(state, payload) {
      state.channel.name = payload;
    },
    SET_CHANNEL_DISK(state, payload) {
      state.channelDisk = payload;
    },
    SET_PAGE_OPTIONS(state, payload) {
      state.pageOptions = payload;
    },
    SET_PROFILE_IMAGE(state, payload) {
      state.channel.profileImage = payload;
    },
    SET_TIME_ID_ONLINE(state, payload) {
      state.timeIdOnline = payload;
    },

    SET_UPLOADING_CONTENT(state, payload) {
      const mode = payload.mode;
      const file_id = payload.file_id;
      const progress = payload.progress;
      const status = payload.status;
      const xhr = payload.xhr;
      console.log("SET_UPLOADING_CONTENT", {
        mode,
        file_id,
        progress,
        status,
        xhr
      });
      if (mode == "add") {
        state.uploadingContent.push(payload);
      }
      if (mode == "update") {
        console.log("update!!!!", state.uploadingContent, file_id);
        const idx = state.uploadingContent.findIndex(
          item => item.file_id == file_id
        );
        if (idx >= 0) {
          state.uploadingContent[idx].progress = progress;
          state.uploadingContent[idx].status =
            status.toUpperCase() + " " + showPercent(progress);
          console.log(
            idx,
            state.uploadingContent[idx].progress,
            state.uploadingContent[idx].status
          );
        }
        console.log("mode update end!");
      }
      if (mode == "failed") {
        const idx = state.uploadingContent.findIndex(
          item => item.file_id == file_id
        );
        if (idx >= 0) state.uploadingContent[idx].status = status;
      }
      if (mode == "ready") {
        const idx = state.uploadingContent.findIndex(
          item => item.file_id == file_id
        );
        if (idx >= 0) state.uploadingContent[idx].xhr = xhr;
      }
      if (mode == "delete") {
        state.uploadingContent = state.uploadingContent.filter(
          item => item.file_id != file_id
        );
      }
    }
  },
  actions: {
    async signIn({ state, commit, dispatch }, signInfo) {
      /**
       * 1. 코그니토 사인 인
       * 2. state.user 설정
       * 3. 다음 리프레시 토큰 시간 설정
       */

      // 1. 사인 인
      const user = await this.$Auth
        .signIn(signInfo.email, signInfo.password)
        .catch(() => {
          Vue.notify({
            title: "Sign In failed",
            type: "error", // success, error, warning
            text: "Please check your email and password.",
            duration: 10000,
            closeOnClick: true
          });
          console.log("사인인 실패");
        });
      if (user) {
        // 2. state.user 설정, 리프레시 타임 설정
        user.getSession(async function(err, session) {
          if (err) {
            alert(err);
            return;
          }
          if (!session.isValid()) return;
          const idToken = session.getIdToken().getJwtToken();
          if (!idToken) return;
          const authTime = jwtDecode(idToken).auth_time;
          const email = jwtDecode(idToken).email;

          // user 객체로부터 토큰을 스토어에 저장, 앱은 이 값 여부에 따라 로그인 상태인지 확인
          const userInfo = {
            email,
            authTime,
            idToken
          };
          commit("SET_USER", userInfo);
        });

        // 채널정보 가져 온 후 목적지로 이동
        console.log({ signInfo });
        let channelId = null;
        let url = null;
        if (signInfo.redirect) {
          url = signInfo.redirect; // /kita/dashboards
          // channelId = url.split("/")[1];
          channelId = state.channelId;
        }

        console.log(channelId, state.user);

        if (channelId) {
          if (state.user) {
            try {
              commit("SET_CHANNEL_ID", channelId);
              await dispatch("getChannelProfile", channelId);
              console.log({ url });
              router.push(url).catch(() => {});
            } catch (e) {
              // console.log(e);
              // await dispatch("signout");
            }
          }
        } else {
          router.push({ name: "Channel" }).catch(() => {});
        }
      }
      console.log("sign in 끝");
    },
    async signOut({ state, commit, dispatch }, redirectMode) {
      console.log("signOut 시작", moment().format("hh:mm:ss"));
      // 오프라인
      if (state.user) {
        await dispatch("offline");
      }

      // 코그니토 사인아웃
      try {
        await this.$Auth.signOut({});
      } catch (e) {
        console.log("error signing out: ", e);
      }
      commit("SET_USER", null);

      // 페이지 이동
      if (redirectMode != "stay") {
        if (state.channelId) {
          console.log(state.channelId);
          router
            .push({
              name: "SignIn",
              query: { redirect: `/${state.channelId}/dashboards` }
            })
            .catch(() => {});
        } else {
          router.push({ name: "Channel" }).catch(() => {});
        }
      }
      // console.log(moment().format("hh:mm:ss"));
    },
    async getChannelProfile({ commit }, payload) {
      /**
       * 채널 정보 설정 (라이센스, 채널명, 프로필이미지)
       *
       */
      console.log("getChannelProfile", payload);
      try {
        const { data } = await apolloClient.query({
          query: getChannelProfile,
          variables: {
            id: payload
          },
          fetchPolicy: "no-cache"
        });
        if (data.getChannelByPublic) {
          const licenses = data.getChannelByPublic.licenses;
          const basicLicense = licenses.filter(lic => {
            const n = moment();
            const s = moment(lic.start);
            const e = moment(lic.end);
            return n >= s && e >= n && lic.mode == "basic";
          });

          console.log({ basicLicense });
          const validLicenses = licenses.filter(lic => {
            const n = moment();
            const s = moment(lic.start);
            const e = moment(lic.end);
            const id =
              Array.isArray(basicLicense) && basicLicense.length > 0
                ? basicLicense[0].id
                : 0;
            return n >= s && e >= n && id == lic.basic_id;
          });
          console.log({ validLicenses });
          const lics = [...basicLicense, ...validLicenses];

          const channel = {};
          channel.channelId = payload;
          channel.name = data.getChannelByPublic.name;
          channel.licenses = lics;
          channel.profileImage = data.getChannelByPublic.profile_image;
          console.log({ channel });
          commit("SET_CHANNEL", channel);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getChannelDisk({ state, commit }, payload) {
      /**
       * 채널의 디스크 사용량 체크 및 업데이트
       */
      console.log("getChannelDisk", payload);
      const channelId = payload;
      const disk = {};
      disk.alloc = 0;
      disk.usage = 0;
      disk.usageRatio = 0;

      // 채널 디스크 할당량 확인
      const diskLicenses = state.channel.licenses.filter(
        license => license.mode == "disk" || license.mode == "basic"
      );
      diskLicenses.forEach(lic => {
        disk.alloc = disk.alloc + lic.disk;
      });

      // 채널 디스크 사용량 확인
      try {
        const result = await Vue.prototype.$axiosAuth.get(
          `/admin/getDiskSize?channel_id=${channelId}`,
          {
            headers: {
              Authorization: `Bearer ${this.state.user.idToken}`
            }
          }
        );
        if (result && result.status == 200) {
          // disk alloc의 사이즈가 GB 단위이기 때문에 disk usage도 GB로 단위를 맞추자.
          disk.usage = Math.floor(result.data.totalSize / (1024 * 1024 * 1024));
          disk.usageRate = Math.ceil((disk.usage / disk.alloc) * 100 * 10) / 10;
        }
        commit("SET_CHANNEL_DISK", disk);
      } catch (error) {
        console.log(error);
      }
    },
    async init({ state, commit, dispatch }) {
      /* 
        1. 채널ID 추출, SET_CHANNEL_ID 커밋
        2. 사용자 정보 세팅 , online
        3. 채널 정보 가져오기
        4. 채널 디스크 사용량 가져오기
        초기화시 라우팅은 최대한 하지 않는다. (모든 라우팅 권한과 세팅은 라우터에서 해결한다)
      */

      console.log("[Init start]");
      // 1. 채널 아이디 추출
      let channelId = null;
      const path = window.location.href;
      const pathArr = path.split("/");

      if (pathArr[2].includes("localhost")) {
        // 개발용의 경우 루트를 기준으로  http://localhost/kita
        channelId = pathArr[3];
      } else {
        // 퍼블리시의 경우 http://onseminar.com/console/channel/kita
        channelId = pathArr[5];
      }
      if (channelId && channelId != "authentication") {
        commit("SET_CHANNEL_ID", channelId);
      } else {
        commit("SET_CHANNEL_ID", null);
      }
      console.log({ "State's ChannelId": state.channelId });

      // 2. 사용자 정보 세팅
      try {
        // 사용자 정보 저장
        const currentSession = await this.$Auth.currentSession();
        const idToken = currentSession.getIdToken().getJwtToken();
        const userInfo = {};
        userInfo.email = jwtDecode(idToken).email;
        userInfo.authTime = jwtDecode(idToken).auth_time;
        userInfo.idToken = idToken;

        console.log("init", { currentSession, idToken });
        commit("SET_USER", userInfo);
      } catch (e) {
        // 실제 라우터가 작동하기 때문에 여기서는 라우팅을 하지 않아야 한다.
        console.log("init중 사용자 없음");
      }

      // 채널 정보 가져오기, 채널 disk 정보 가져오기
      if (channelId && state.user) {
        try {
          await dispatch("getChannelProfile", channelId);
        } catch (e) {
          console.log("err", e);
        }
      }

      console.log("[Init]", {
        channelId,
        userInfo: state.user,
        channel: state.channel
      });
      console.log("[Init end]");
    },

    // eslint-disable-next-line
    async logger({ commit }, params) {
      /**
       * params { category, level, menu, message }
       * category : "service", "channel" , "live", "presenter"
       * level : "Success, Error"
       * menu : "Users", "Groups", "Dashboards", ...
       * message: full text
       *
       * 1. 클라이언트 알림   this.$nofity
       * 2. 서버로그 기록     this.$apollo
       */
      if (!params.category) params.category = "Channel";
      if (!params.level) params.level = "Success";

      const title = params.menu;
      const type = params.level;
      const text = params.message;
      const duration = 6000;

      const category = params.category;
      const menu = params.menu;
      const level = params.level;
      const message =
        typeof params.message == "string"
          ? params.message.replace("<br>", " ")
          : "";
      console.log({
        title,
        type,
        text,
        duration,
        category,
        level,
        message,
        menu
      });

      Vue.notify({
        title: title,
        type: type, // success, error, warning
        text: text,
        duration: duration,
        closeOnClick: true
      });

      try {
        const data = await apolloClient.mutate({
          mutation: createLog,
          variables: {
            category: category,
            menu: menu,
            level: level, // success, error
            channel_id: this.state.channelId,
            message: message
          }
        });
        console.log(data);
      } catch (e) {
        console.log("[logger]", e);
      }
    },

    async online({ state, commit, dispatch }) {
      console.log("online 시작");
      const channelId = state.channelId;
      const liveId = state.liveId;
      const user_agent = navigator.userAgent;
      const email = state.user.email;
      const auth_time = state.user.authTime;
      const ip = state.ip;
      const app = "channelManager";

      const input = {};
      if (channelId) input.channel_id = channelId;
      if (liveId) input.live_id = liveId;
      if (user_agent) input.user_agent = user_agent;
      if (email) input.email = email;
      if (auth_time) input.auth_time = auth_time;
      if (ip) input.ip = ip;
      if (app) input.app = app;
      if (state.onlineId) {
        console.log("onlineId 존재", state.onlineId);
        input.id = state.onlineId;
      } else {
        console.log("onlineId 없음", state.onlineId);
      }

      const result = await apolloClient.mutate({
        mutation: createOnline,
        variables: {
          input
        },
        fetchPolicy: "no-cache"
      });

      if (result.data && result.data.createOnline) {
        const onlineId = result.data.createOnline.id;
        const mode = result.data.createOnline.mode;

        console.log(
          "createOnline 리턴",
          result.data.createOnline,
          onlineId,
          mode
        );
        if (mode == "online") {
          console.log("온라인을 유지하라는 mode로 online을 받음", onlineId);
          commit("SET_ONLINE_ID", onlineId);
          // 혹 누락되어 죽지 않는 타이머가 생길까봐 혹시 삭제
          if (state.timeIdOnline) {
            clearTimeout(state.timeIdOnline);
            commit("SET_TIME_ID_ONLINE", null);
          }
          // 다음 online알림 예약
          const timeId = setTimeout(async function() {
            await dispatch("online");
          }, 30000);
          commit("SET_TIME_ID_ONLINE", timeId);
        }

        if (mode == "offline") {
          // 사인 아웃
          console.log("리턴이 offline이므로 signout");
          await dispatch("signOut");
          commit("SET_ONLINE_ID", "");
          // 반복실행 취소
          if (state.timeIdOnline) {
            clearTimeout(state.timeIdOnline);
            commit("SET_TIME_ID_ONLINE", null);
          }
        }

        if (mode == "block") {
          // 반복실행 금지
          if (state.timeIdOnline) {
            clearTimeout(state.timeIdOnline);
            commit("SET_TIME_ID_ONLINE", null);
          }
          // 로그아웃은 안 한채 블록페이지로.. 만일 로그아웃을 시킨다면 같은 창에서 나중에 들어것도 로그아웃됨
          commit("SET_ONLINE_ID", "");
          // 반복실행 취소
          if (state.timeIdOnline) {
            clearTimeout(state.timeIdOnline);
            commit("SET_TIME_ID_ONLINE", null);
          }
          // 블록페이지로 이동
          router
            .push({
              name: "Error403",
              params: { code: "block" }
            })
            .catch(() => {});
        }
      } else {
        console.log("createOnline 이 어떤 이유에서인지 실패, 30초 후 재 시도");
        if (state.timeIdOnline) {
          clearTimeout(state.timeIdOnline);
          commit("SET_TIME_ID_ONLINE", null);
        }
        const timeId = setTimeout(async function() {
          await dispatch("online");
        }, 30000);
        // console.log("online) 다음 online time Id 설정", timeId);
        commit("SET_TIME_ID_ONLINE", timeId);
      }
    },
    async offline({ state, commit }) {
      if (state.onlineId) {
        try {
          await apolloClient.mutate({
            mutation: deleteOnline,
            variables: {
              input: {
                id: state.onlineId
              }
            },
            fetchPolicy: "no-cache"
          });
        } catch (e) {
          console.log("offline error", e);
        }
        commit("SET_ONLINE_ID", "");
      }

      // console.log('timeId', state.timeIdOnline, data)    .
      if (state.timeIdOnline) {
        // console.log("offline) online timer Id 삭제");
        clearTimeout(state.timeIdOnline);
        commit("SET_TIME_ID_ONLINE", null);
      }
    },
    uploadVideo({ commit, dispatch, state }, params) {
      // 워커로부터오는 메시지 핸들러
      uploadWorker.worker.onmessage = async event => {
        const { data } = event;
        console.log("uploadVideo", { data });
        const file_id = data.file_id;
        const status = data.status;
        const progress = data.progress;
        const xhr = data.xhr;

        const file = {
          mode: "update",
          file_id,
          status,
          progress,
          xhr
        };

        if (status == "completed") {
          file.mode = "delete";
          const input = {
            id: file_id,
            channel_id: state.channelId,
            status: "PENDING"
          };
          console.log("input", input);
          console.log("updateContent 전");
          await dispatch("updateContent", input);
          console.log("updateContent 후");
        }

        if (status == "failed") file.mode = "delete";
        if (status == "ready") file.mode = "ready";

        commit("SET_UPLOADING_CONTENT", file);
      };
      // 워커 시작
      const file = {
        mode: "add",
        file_id: params.file_id,
        file_name: params.file_name,
        progress: 0,
        status: "ready"
      };
      commit("SET_UPLOADING_CONTENT", file);

      uploadWorker.send(params);
    },
    abortVideo({ commit }, file_id) {
      // 네트워크 전송 취소
      const sendMessage = {
        mode: "stop",
        file_id: file_id
      };
      uploadWorker.send(sendMessage);

      // store에 업로드 현황 삭제
      const file = {
        mode: "delete",
        file_id: file_id
      };
      commit("SET_UPLOADING_CONTENT", file);

      // 컨텐츠 정보 업데이트
      // status 가 uploading중에 취소되었으므로 db에는 uploading 상태로 남아 있고, 스케쥴잡에 의해 나중에 삭제
    },
    async updateContent({ state }, input) {
      console.log({ state });
      try {
        const data = await apolloClient.mutate({
          mutation: updateContent,
          variables: {
            input
          }
        });
        console.log("업데이트 결과", { data });
      } catch (e) {
        console.log("[UpdateContent]", e);
      }
    }
  }
});
